import {
  IconBuilding,
  IconCalendar,
  IconCard,
  IconClubs,
  IconFlag,
  IconLeaderboard,
  IconMessage,
  IconPokerChip,
  IconReport,
  IconSettings,
  IconUsers,
} from '@ui/icons'

export type NavItem = {
  to: string
  labelKey: string
  shortLabelKey: string
  Icon: typeof IconCalendar
  exact?: boolean
}

export const ACCOUNT_NAV: NavItem[] = [
  {
    to: '/events',
    labelKey: 'nav.events',
    shortLabelKey: 'nav-short.events',
    Icon: IconCalendar,
  },
  {
    to: '/users',
    labelKey: 'nav.users',
    shortLabelKey: 'nav-short.users',
    Icon: IconUsers,
  },
  {
    to: '/account-settings',
    labelKey: 'nav.account-settings',
    shortLabelKey: 'nav-short.account',
    Icon: IconSettings,
  },
]

export const PLATFORM_NAV: NavItem[] = [
  {
    to: '/platform/accounts',
    labelKey: 'nav.accounts',
    shortLabelKey: 'nav.accounts',
    Icon: IconBuilding,
  },
  {
    to: '/platform/courses',
    labelKey: 'nav.courses',
    shortLabelKey: 'nav-short.courses',
    Icon: IconClubs,
  },
  {
    to: '/platform/vipps-payments',
    labelKey: 'nav.vipps-payments',
    shortLabelKey: 'nav.vipps-payments',
    Icon: IconCard,
  },
  {
    to: '/platform/sms',
    labelKey: 'nav.sms',
    shortLabelKey: 'nav.sms',
    Icon: IconMessage,
  },
  {
    to: '/platform/reports',
    labelKey: 'nav.reports',
    shortLabelKey: 'nav.reports',
    Icon: IconReport,
  },
]

export const EVENT_NAV = (eventId: string, mode?: string | null): NavItem[] => {
  const isTeamMode = mode === 'SCRAMBLE' || mode === 'BESTBALL'
  const items: NavItem[] = [
    {
      to: `/events/${eventId}/summary`,
      labelKey: 'nav.event-summary',
      shortLabelKey: 'nav-short.summary',
      Icon: IconLeaderboard,
    },
    {
      to: `/events/${eventId}/players`,
      labelKey: 'nav.event-players',
      shortLabelKey: 'nav-short.players',
      Icon: IconUsers,
    },
  ]
  if (isTeamMode) {
    items.push({
      to: `/events/${eventId}/teams`,
      labelKey: 'nav.event-teams',
      shortLabelKey: 'nav-short.teams',
      Icon: IconUsers,
    })
  }
  items.push({
    to: `/events/${eventId}/flights`,
    labelKey: 'nav.event-flights',
    shortLabelKey: 'nav-short.flights',
    Icon: IconFlag,
  })
  if (mode === 'POLF') {
    items.push({
      to: `/events/${eventId}/poker`,
      labelKey: 'nav.event-poker',
      shortLabelKey: 'nav-short.poker',
      Icon: IconPokerChip,
    })
  }
  items.push({
    to: `/events/${eventId}/settings`,
    labelKey: 'nav.event-settings',
    shortLabelKey: 'nav-short.settings',
    Icon: IconSettings,
  })
  return items
}
